module.exports = __webpack_public_path__ + "static/logo-header-2-50f5a01f5bd37e107a186c5f44904177.png";